// extracted by mini-css-extract-plugin
export default {"wrapper":"Transacao_wrapper__bQG9w","detalhe__superior":"Transacao_detalhe__superior__qqv1D","detalhe__inferior":"Transacao_detalhe__inferior__Y1Pvf"};